import {of as observableOf, Observable, BehaviorSubject} from 'rxjs';

import {map, takeWhile, first, catchError} from 'rxjs/operators';
import {ChangeDetectorRef, Component, Input, NgZone} from '@angular/core';
import {AbstractControlComponent} from './abstract-control';
import {ViewTabComponent} from '../viewtab.component';
import {ValuesObject} from '../detail-tabconfig';
import {CacheService} from '../../../cache/cache.service';
import {DisplayAttribute} from '../../displayattribute';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {LanguageService} from '../../../language/language.service';
import {ErrorService} from '../../../error/error.service';
import {ModuleService} from '../../../module/module.service';
import {ExportConfig, ModuleConfig, UIModule} from '../../../module/moduleconfig';
import {DialogsService} from '../../../shared/dialog/dialogs.service';

@Component({
  selector: 'ctrl-modulesync',
  template: `
    <button mat-raised-button (click)="export()">Export</button>
    <button mat-raised-button (click)="sync()">Sync</button>
    <button mat-raised-button (click)="apply()">Apply</button>
    <p>{{ installerText | async }}</p>
  `,
  standalone: false,
})
export class CtrlModuleSyncComponent extends AbstractControlComponent {
  private installerTextSource = new BehaviorSubject<string>('Export');
  installerText: Observable<string>;

  constructor(
    parent: ViewTabComponent,
    changeDetector: ChangeDetectorRef,
    ngZone: NgZone,
    private cacheService: CacheService,
    private sanitizer: DomSanitizer,
    errorService: ErrorService,
    private dataService: ModuleService,
    private dialogsService: DialogsService,
  ) {
    super(parent, 'Value', 'Value', changeDetector, ngZone, errorService);
    this.installerText = this.installerTextSource.asObservable();
  }

  export() {
    this.getCaughtObservable(this._config.getPropertyValues('ObjectID'))
      .pipe(takeWhile(() => this.alive))
      .subscribe((objectid: string) => {
        this.getCaughtObservable(this._config.getPropertyValues('Filter'))
          .pipe(takeWhile(() => this.alive))
          .subscribe((filter: string[]) => {
            let module: UIModule = <UIModule>{
              ID: objectid,
              Filter: filter,
            };
            this.dataService
              .exportModule(module, this.installerTextSource)
              .subscribe(() => this.dialogsService.message('UI Module', 'Finished!'));
          });
      });
  }

  sync() {
    this.getCaughtObservable(this._config.getPropertyValues('ObjectID'))
      .pipe(takeWhile(() => this.alive))
      .subscribe((objectid: string) => {
        this.getCaughtObservable(this._config.getPropertyValues('Filter'))
          .pipe(takeWhile(() => this.alive))
          .subscribe((filter: string[]) => {
            this.getCaughtObservable(this._config.getPropertyValues('ImportConfig'))
              .pipe(takeWhile(() => this.alive))
              .subscribe((importConfig: string) => {
                this.getCaughtObservable(this._config.getPropertyValues('ExportConfig'))
                  .pipe(takeWhile(() => this.alive))
                  .subscribe((exportConfig: string) => {
                    let module: UIModule = <UIModule>{
                      ID: objectid,
                      Filter: filter,
                      ExportConfig: exportConfig,
                      ImportConfig: importConfig,
                    };
                    this.dataService
                      .syncModule(module, this.installerTextSource)
                      .subscribe(() => this.dialogsService.message('UI Module', 'Finished!'));
                  });
              });
          });
      });
  }
  public b64DecodeUnicode(str) {
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );
  }
  apply() {
    this.getCaughtObservable(this._config.getPropertyValues('ObjectID'))
      .pipe(takeWhile(() => this.alive))
      .subscribe((objectid: string) => {
        this.getCaughtObservable(this._config.getPropertyValues('ChangeConfig'))
          .pipe(takeWhile(() => this.alive))
          .subscribe((changeConfig: ModuleConfig[]) => {
            this.dataService
              .installModule(
                JSON.parse(this.b64DecodeUnicode(changeConfig)),
                this.installerTextSource,
              )
              .subscribe(() => this.dialogsService.message('UI Module', 'Applied!'));
          });
      });
  }
}
